var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cq-btn"},[_c('div',{staticClass:"behind-btn"},[_c('b-button',{staticClass:"btn",class:{'btn-primary': !_vm.inverse, 'btn-white': _vm.inverse, 'middle' : _vm.centerfloatbtn}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }